import { render, staticRenderFns } from "./ProfileMenu.vue?vue&type=template&id=b979a83c&scoped=true"
import script from "./ProfileMenu.vue?vue&type=script&lang=js"
export * from "./ProfileMenu.vue?vue&type=script&lang=js"
import style0 from "./ProfileMenu.vue?vue&type=style&index=0&id=b979a83c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b979a83c",
  null
  
)

export default component.exports